'use client';

import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';

export default function Header() {
  const pathname = usePathname();
  const { data: session, status } = useSession();

  return (
    <header className="border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-between items-center min-h-16 gap-y-2 py-2 sm:flex-nowrap">
          <Link href="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <Image
              src="/logo.svg"
              alt="Combine logo"
              width={48}
              height={48}
              className="w-12 h-12"
              priority
            />
            <span className="text-lg sm:text-xl font-bold">combine.run</span>
          </Link>

          <nav className="flex w-full items-center justify-between gap-3 pb-1 sm:w-auto sm:justify-start sm:gap-6 sm:pb-0">
            <Link
              href="/"
              className={`text-sm font-medium transition-colors ${
                pathname === '/'
                  ? 'text-foreground'
                  : 'text-gray-600 dark:text-gray-400 hover:text-foreground'
              }`}
            >
              Home
            </Link>
            <Link
              href="/dashboard"
              className={`text-sm font-medium transition-colors ${
                pathname === '/dashboard'
                  ? 'text-foreground'
                  : 'text-gray-600 dark:text-gray-400 hover:text-foreground'
              }`}
            >
              Dashboard
            </Link>

            {/* Strava Login Button */}
            {status !== 'loading' && !session && (
              <Link href="/#strava-connect" className="text-sm font-medium underline underline-offset-4">Connect to Strava</Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}
